const property = {
  bedrooms:   "Bedrooms",
  bathrooms:  "Bathrooms",
  sqft:       "Sq ft",
  type:       "Type",
  description:"Description",
  amenities:  "Amenities",
  details:    "Details",
  developer:  "Developer",
  status:     "Status",
  location:   "Location",
  size:       "Size",
  source:     "Source",
  perYear:    "per year",
  viewAll_one:   "View all {{count}} photo",
  viewAll_other: "View all {{count}} photos",
  youMayLike: "You may also like",
  similar:    "Similar",
  similarEm:  "properties",
  whatsapp:   "WhatsApp agent",
  telegram:   "Telegram",
  notFound:   "Property not found",
  backToListings: "← Back to listings",
};

export default property;
